import React from 'react';
import 'remixicon/fonts/remixicon.css'

import {setFavouritesIsActive} from "../../Features/Misc/navBarSlice"
import {useDispatch, useSelector} from "react-redux";
import {setDashBoardIsActive} from "../../Features/Misc/activeSlice";


import SearchBar from "./SearchBar";
import MiniOffCanvas from "./MiniOffCanvas";
import UserOffCanvas from "../structure/UserOffcanvas/UserOffCanvas";

export default function MiniNav(props) {

    //changed this
    // const { first_name, last_name } = useSelector((state) => state.auth.user)
    const {first_name} = useSelector((state) => state.auth.user)

    const dispatch = useDispatch()

    const takeMeToFavourites = () => {
        dispatch(setDashBoardIsActive())
        dispatch(setFavouritesIsActive())
    }

    return (
        <nav
            className={`MiniNav flex flex-col gap-4 sm:gap-4 row-start-1 w-full items-center row-end-4 bg-purple-dashboard lg:hidden col-start-1 col-end-25`}>

            <div
                className="MiniNav__topRow w-full h-16 flex flex-row justify-between items-center bg-purple-slumber rounded-b-lg px-4 mb-2">
                <div className="flex flex-row items-center w-full justify-between">
                    {/*<img  src="./KipMate_logo.svg" alt=""/>*/}
                    <img className="w-32" src="https://www.kipmate.com/sortyourkip/client/build/kmlogo.svg" alt=""/>
                    <div className="flex flex-row gap-4 items-center">
                        <i onClick={() => (takeMeToFavourites())}
                           className="ri-heart-2-line text-pink-icon text-3xl"></i>
                        <MiniOffCanvas
                            customHeight=" h-12 "
                            customWidth=" w-12 "
                            customMinWidth=" min-w-12 "
                        />
                    </div>
                </div>
            </div>

            <div className="MiniNav__MiddleRow w-full flex flex-row justify-between items-center px-4">

                <div className="text-2xl text-white MiniNav__MiddleRow__title text-left grow">Dashboard</div>

                <div className="flex flex-row gap-4 items-center">
                    <div
                        className="hidden w-full sm:w-72 sm:flex flex-row items-center px-4 justify-center sm:justify-end text-2xl">
                        <SearchBar width={"w-72 lg:w-96"} className={""}/>
                    </div>

                    <div
                        className="MiniNav__middleRow__aviSection flex flex-row gap-4 items-center justify-end">
                        <div
                            className="MiniNav__middleRow__aviSection__name flex items-center text-white text-base">{first_name.charAt(0).toUpperCase() + first_name.slice(1).toLowerCase()}</div>

                        <UserOffCanvas customWidth={"w-10"} customHeight={"h-10"} customMinWidth={"min-w-10"}/>
                    </div>
                </div>

            </div>

            <div className="w-full flex flex-row items-center px-4 justify-center sm:justify-end text-2xl sm:hidden">
                <SearchBar width={"w-11/12"} className={""}/>
            </div>


        </nav>

    );
}
